'use client';
import { Props as BackToSchoolProps } from './back-to-school.component';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicBackToSchoolComponent: ComponentType<BackToSchoolProps> = dynamic(
  () => import('./back-to-school.component')
);

export default DynamicBackToSchoolComponent;

export function calculateBackToSchoolPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
